// extracted by mini-css-extract-plugin
export default {"loading":"role-permission-modal_loading__XO+W3"};